import { useImpersonating } from "@/hooks/useImpersonating";

export function SuperAdminBanner() {
  const { isImpersonating, targetName, stopImpersonating } = useImpersonating();

  if (!isImpersonating) return null;

  return (
    <div className="bg-primary text-primary-foreground px-4 py-2 text-sm font-medium flex items-center justify-center gap-3 z-[9999] relative">
      <span>⚠️ Viewing as {targetName}</span>
      <button
        onClick={stopImpersonating}
        className="underline hover:no-underline font-semibold"
      >
        Exit
      </button>
    </div>
  );
}
